import DoubtList from './DoubtList';
import DoubtEdit from './DoubtEdit';
import {Image} from "@mui/icons-material";

export default {
    list: DoubtList,
    edit: DoubtEdit,
    icon: Image,
};
